module.exports = __webpack_public_path__ + "img/logo.c6b8e433.png";